/**
 * @fileoverview PUT handler for the "/engagement/conversion_report" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementConversionReportCacheKeys } from "./constants";
import type { PutEngagementConversionReportProps, PutEngagementConversionReportResult } from "./types";

export const putEngagementConversionReport = reactQueryMutationAdapter(
  engagementConversionReportCacheKeys,
  (props: PutEngagementConversionReportProps): Promise<PutEngagementConversionReportResult> => {
    return fetch("/engagement/conversion_report", "PUT", props, {}, { propagateFetchRequestError: false });
  }
);
